import { MenuItem, TextField } from "@mui/material"
import { flagForLanguage, REGISTRATION_LANGUAGES } from "@utils/language"

function StudentLanguageSelector(props: {
  language: string | undefined
  onLanguageChange: (language: string) => void
  size?: "small" | "medium"
}) {
  const { language, onLanguageChange, size } = props

  return (
    <TextField
      select
      label="Registration language"
      size={size}
      value={language ?? ""}
      onChange={(e) => onLanguageChange(e.target.value)}
    >
      {REGISTRATION_LANGUAGES.map((option) => (
        <MenuItem key={option} value={option}>
          {`${flagForLanguage(option)} ${capitalize(option)}`}
        </MenuItem>
      ))}
    </TextField>
  )
}

function capitalize(value: string) {
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export default StudentLanguageSelector
